import BANNER_IMG from "./banner.jpg";
import LOGO from "./logo.jpg";

function kindFields(t, kind) {
  return { kind, kindLabel: t.kind[kind] };
}

export function getPageData(t) {
  return {
    nav: {
      logo: LOGO,
      menu: {
        items: [
          {
            name: t.nav.products,
            children: [
              {
                name: t.productsNav.bdf,
                href: "/products/bdf",
                desc: t.productsNav.bdfDesc,
              },
              {
                name: t.productsNav.cxl,
                href: "/#cxl",
                desc: t.productsNav.cxlDesc,
              },
            ],
          },
          {
            name: t.nav.solutions,
            children: [
              {
                name: t.productsNav.cwp,
                href: "/#cwp",
                desc: t.productsNav.cwpDesc,
              },
              {
                name: t.productsNav.token,
                href: "/#token",
                desc: t.productsNav.tokenDesc,
              },
              {
                name: t.productsNav.firmware,
                href: "/#firmware",
                desc: t.productsNav.firmwareDesc,
              },
            ],
          },
          {
            name: t.nav.resources,
            children: [
              {
                name: t.resources.brief,
                href: "/downloads/bdf-datasheet.pdf",
                desc: t.resources.briefDesc,
              },
              {
                name: t.resources.blog,
                href: "/blog",
                desc: t.resources.blogDesc,
              },
            ],
          },
          { name: t.nav.blog, href: "/blog" },
        ],
        cta: { name: t.nav.contact, href: "#contact" },
      },
    },
    banner: {
      title: t.hero.title,
      titleAccent: t.hero.titleAccent,
      desc: t.hero.desc,
      introImg: BANNER_IMG,
      button: t.hero.explore,
      buttonHref: "#products",
      linksLabel: t.grid.kicker,
      links: [
        { name: t.productsNav.bdf, href: "/products/bdf" },
        { name: t.productsNav.cxl, href: "#cxl" },
        { name: t.productsNav.cwp, href: "#cwp" },
        { name: t.productsNav.token, href: "#token" },
        { name: t.productsNav.firmware, href: "#firmware" },
      ],
    },
    products: {
      id: "products",
      kicker: t.grid.kicker,
      title: t.grid.title,
      subtitle: t.grid.subtitle,
      items: [
        {
          name: "bdf",
          title: t.productsNav.bdf,
          desc: t.grid.bdfDesc,
          href: "/products/bdf",
          tags: ["QLC", "KV cache", "5× endurance"],
          ...kindFields(t, "product"),
        },
        {
          name: "cxl",
          title: t.productsNav.cxl,
          desc: t.grid.cxlDesc,
          href: "#cxl",
          tags: ["CXL.mem", "CXL.io", "Pooling"],
          ...kindFields(t, "product"),
        },
        {
          name: "cwp",
          title: t.productsNav.cwp,
          desc: t.grid.cwpDesc,
          href: "#cwp",
          tags: ["Hosts", "GPU", "BMC"],
          ...kindFields(t, "solution"),
        },
        {
          name: "token",
          title: t.productsNav.token,
          desc: t.grid.tokenDesc,
          href: "#token",
          tags: ["OpenAI API", "Routing", "Quotas"],
          ...kindFields(t, "solution"),
        },
        {
          name: "firmware",
          title: t.productsNav.firmware,
          desc: t.grid.firmwareDesc,
          href: "#firmware",
          tags: ["UEFI", "USF", "SlimBMC"],
          ...kindFields(t, "solution"),
        },
      ],
    },
    bdf: {
      id: "bdf",
      ...kindFields(t, "product"),
      title: t.productsNav.bdf,
      eyebrow: t.bdf.eyebrow,
      subtitle: t.bdf.subtitle,
      desc: t.bdf.desc,
      highlights: [t.bdf.h1, t.bdf.h2, t.bdf.h3],
      button: t.bdf.button,
      href: "/products/bdf",
      imgAlt: t.bdf.imgAlt,
      metrics: [
        { value: "118 GB/s", label: t.bdf.m1 },
        { value: "5.0M", label: t.bdf.m2 },
        { value: "WAF ≈ 1.0", label: t.bdf.m3 },
        { value: "1.6 PB", label: t.bdf.m4 },
      ],
    },
    bdfScenarios: {
      id: "bdf-scenarios",
      kicker: t.bdfScenarios.kicker,
      title: t.bdfScenarios.title,
      subtitle: t.bdfScenarios.subtitle,
      items: [
        {
          tag: t.bdfScenarios.i1Tag,
          title: t.bdfScenarios.i1Title,
          desc: t.bdfScenarios.i1Desc,
        },
        {
          tag: t.bdfScenarios.i2Tag,
          title: t.bdfScenarios.i2Title,
          desc: t.bdfScenarios.i2Desc,
        },
        {
          tag: t.bdfScenarios.i3Tag,
          title: t.bdfScenarios.i3Title,
          desc: t.bdfScenarios.i3Desc,
        },
        {
          tag: t.bdfScenarios.i4Tag,
          title: t.bdfScenarios.i4Title,
          desc: t.bdfScenarios.i4Desc,
        },
      ],
    },
    cxl: {
      id: "cxl",
      alt: true,
      reverse: true,
      ...kindFields(t, "product"),
      title: t.productsNav.cxl,
      eyebrow: t.cxl.eyebrow,
      subtitle: t.cxl.subtitle,
      desc: t.cxl.desc,
      highlights: [t.cxl.h1, t.cxl.h2, t.cxl.h3],
      button: t.cxl.button,
      href: "#contact",
      points: [
        { title: t.cxl.p1Title, desc: t.cxl.p1Desc },
        { title: t.cxl.p2Title, desc: t.cxl.p2Desc },
        { title: t.cxl.p3Title, desc: t.cxl.p3Desc },
        { title: t.cxl.p4Title, desc: t.cxl.p4Desc },
      ],
    },
    cwp: {
      id: "cwp",
      ...kindFields(t, "solution"),
      title: t.productsNav.cwp,
      eyebrow: t.cwp.eyebrow,
      subtitle: t.cwp.subtitle,
      desc: t.cwp.desc,
      highlights: [t.cwp.h1, t.cwp.h2, t.cwp.h3, t.cwp.h4],
      imgAlt: t.cwp.imgAlt,
    },
    cwpUse: {
      id: "cwpsolutions",
      kicker: t.cwpUse.kicker,
      title: t.cwpUse.title,
      subtitle: t.cwpUse.subtitle,
      alt: true,
      items: [
        { tag: t.cwpUse.i1Tag, title: t.cwpUse.i1Title, desc: t.cwpUse.i1Desc },
        { tag: t.cwpUse.i2Tag, title: t.cwpUse.i2Title, desc: t.cwpUse.i2Desc },
        { tag: t.cwpUse.i3Tag, title: t.cwpUse.i3Title, desc: t.cwpUse.i3Desc },
        { tag: t.cwpUse.i4Tag, title: t.cwpUse.i4Title, desc: t.cwpUse.i4Desc },
      ],
    },
    token: {
      id: "token",
      ...kindFields(t, "solution"),
      title: t.productsNav.token,
      eyebrow: t.token.eyebrow,
      subtitle: t.token.subtitle,
      desc: t.token.desc,
      highlights: [t.token.h1, t.token.h2, t.token.h3, t.token.h4],
      points: [
        { title: t.token.p1Title, desc: t.token.p1Desc },
        { title: t.token.p2Title, desc: t.token.p2Desc },
        { title: t.token.p3Title, desc: t.token.p3Desc },
        { title: t.token.p4Title, desc: t.token.p4Desc },
      ],
    },
    firmware: {
      id: "firmware",
      alt: true,
      ...kindFields(t, "solution"),
      title: t.productsNav.firmware,
      subtitle: t.firmware.subtitle,
      desc: t.firmware.desc,
      imgAlt: t.firmware.imgAlt,
    },
    footer: {
      email: "",
      briefHref: "/downloads/bdf-datasheet.pdf",
      products: [
        { name: t.productsNav.bdf, href: "/products/bdf" },
        { name: t.productsNav.cxl, href: "/#cxl" },
      ],
      solutions: [
        { name: t.productsNav.cwp, href: "/#cwp" },
        { name: t.productsNav.token, href: "/#token" },
        { name: t.productsNav.firmware, href: "/#firmware" },
      ],
      blog: t.footer.blog,
      brief: t.resources.brief,
      productsLabel: t.footer.products,
      solutionsLabel: t.footer.solutions,
      contactLabel: t.footer.contact,
      copyright: t.footer.copyright,
    },
  };
}
